import { defineComponent as _defineComponent } from 'vue'
import BusStopStreetView from "@/components/map/BusStopStreetView.vue";
import MapZoomLevelSetter from "@/components/map/MapZoomLevelSetter.vue";
import NaverMap from "@/components/map/NaverMap.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Page from "@/components/shared/Page.vue";
import { ILineInfoLite } from "@/domain/entities/lineInfo";
import { useLineStore } from "@/stores/lineStore";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import InlineSvg from "vue-inline-svg";
import PageModal from "@/components/shared/modal/base/PageModal.vue";
import MapOfNearbyBusStopsBottomSheet from "./MapOfNearbyBusStopsBottomSheet.vue";


const __default__ = {
  name: "BusStopInfoMap",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const lineStore = useLineStore();

const route = useRoute();

const busStopId = route.params.busStopUid?.toString() ?? "";
const busStop = lineStore.getBusStopById(busStopId);

const lineInfos = computed<ILineInfoLite[]>(() => {
  if (!busStopId.length) {
    return [];
  }
  return lineStore.getLineInfosLiteByBusStopId(busStopId);
});

/** 지도 Zoom Level */
const MIN_ZOOM_LEVEL = 11;
const MAX_ZOOM_LEVEL = 18;

const zoomLevel = ref(15);
const updateZoomLevel = (level: number) => {
  if (level < MIN_ZOOM_LEVEL || level > MAX_ZOOM_LEVEL) return;

  zoomLevel.value = level;
};

// NavigationBar 아래 10px 위치로 maxHeight 계산
const maxHeightPx = computed(() => {
  const statusBarHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      "--statusbar-height"
    ) || "0"
  );
  const navHeight = 48; // $navHeight 값
  return window.innerHeight - (statusBarHeight + navHeight + 10);
});

/** 거리뷰 화면 */
const shouldShowStreetView = ref(false);
const toggleShowStreetView = (show: boolean) => {
  if (show && !busStop) return;

  shouldShowStreetView.value = show;
};

const __returned__ = { lineStore, route, busStopId, busStop, lineInfos, MIN_ZOOM_LEVEL, MAX_ZOOM_LEVEL, zoomLevel, updateZoomLevel, maxHeightPx, shouldShowStreetView, toggleShowStreetView, BusStopStreetView, MapZoomLevelSetter, NaverMap, NavigationBar, Page, get InlineSvg() { return InlineSvg }, PageModal, MapOfNearbyBusStopsBottomSheet }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})